export const mailDetail = (target: string, params: any) => {
    let detail = {
        title: "",
        body: "",
        type: "",
        staffNoList: [],
        plan_area_id: "",
        branch: "",
        notficationType: "",
    };
    switch (target) {
        case "requestEmail_5mOutsideMarketCut":
            detail.title = `【立地調査】${params.survey_name}　${params.titleDetail}`;
            detail.body = `以下URLより「${params.titleDetail}」をご確認の上、承認・差戻の登録をお願いします。\n\n`;
            detail.body += `ＵＲＬ：${params.url}\n\n`;
            detail.body += `担当RFC：${params.rfc}\n\n`;
            detail.body += `確認担当者：${params.confirmationPerson}`;
            detail.type = params.type;
            detail.staffNoList = params.staffNoList;
            detail.plan_area_id = params.plan_area_id;
            detail.branch = params.branch;
            detail.notficationType = params.notficationType;
            break;
        case "returnEmail_5mOutsideMarketcut":
            detail.title = `【立地調査】${params.survey_name}　${params.titleDetail}差戻`;
            detail.body = `${params.survey_name}の「${params.titleDetail}」が差戻されました。\n\n`;
            detail.body += `確認をお願いします。\n\n`;
            detail.body += `差戻者：${params.operator}\n\n`;
            detail.body += `差戻項目：${params.returnedItems}\n\n`;
            detail.body += `担当RFC：${params.rfc}\n\n`;
            detail.body += `確認担当者：${params.confirmationPerson}`;
            detail.type = params.type;
            detail.staffNoList = params.staffNoList;
            detail.plan_area_id = params.plan_area_id;
            detail.branch = params.branch;
            detail.notficationType = params.notficationType;
            break;
        case "reference":
        case "decision":
            detail.title = `【立地調査】${params.survey_name}　${params.titleDetail}追加調査承認の確認依頼`;
            detail.body = `以下URLより「追加調査」をご確認の上、承認・差戻の登録をお願いします。\n\n`;
            detail.body += `ＵＲＬ：${params.url}\n\n`;
            detail.body += `担当RFC：${params.rfc}\n\n`;
            detail.type = params.type;
            detail.staffNoList = params.staffNoList;
            detail.plan_area_id = params.plan_area_id;
            detail.branch = params.branch;
            detail.notficationType = params.notficationType;
            break;
        case "addSurvey":
            detail.title = `【立地調査】${params.survey_name}　${params.titleDetail}追加調査参考値承認の確認依頼`;
            detail.body = `以下URLより「追加調査」をご確認の上、承認・差戻の登録をお願いします。\n\n`;
            detail.body += `ＵＲＬ：${params.url}\n\n`;
            detail.body += `担当RFC：${params.rfc}\n\n`;
            detail.type = params.type;
            detail.staffNoList = params.staffNoList;
            detail.plan_area_id = params.plan_area_id;
            detail.branch = params.branch;
            detail.notficationType = params.notficationType;
            break;
        case "requestCommentAddSurvey":
            detail.title = `【立地調査】${params.survey_name}　${params.titleDetail}追加調査参考値承認の確認依頼`;
            detail.body = `以下URLより「追加調査」をご確認の上、承認・差戻の登録をお願いします。\n\n`;
            detail.body += `ＵＲＬ：${params.url}\n\n`;
            detail.body += `担当RFC：${params.rfc}\n\n`;
            detail.body += `確認担当：${params.staff_name}\n\n`;
            detail.type = params.type;
            detail.staffNoList = params.staffNoList;
            detail.plan_area_id = params.plan_area_id;
            detail.branch = params.branch;
            detail.notficationType = params.notficationType;
            break;
        case "requestCommentAddSurveyConfirmed":
            detail.title = `【立地調査】${params.survey_name}　${params.titleDetail}追加調査確定値承認の確認依頼`;
            detail.body = `以下URLより「追加調査」をご確認の上、承認・差戻の登録をお願いします。\n\n`;
            detail.body += `ＵＲＬ：${params.url}\n\n`;
            detail.body += `担当RFC：${params.rfc}\n\n`;
            detail.body += `確認担当：${params.staff_name}\n\n`;
            detail.type = params.type;
            detail.staffNoList = params.staffNoList;
            detail.plan_area_id = params.plan_area_id;
            detail.branch = params.branch;
            detail.notficationType = params.notficationType;
            break;
    }

    return detail;
};
